<template lang="html">

  <section>

    <div class="demo-richiedi">

      <section class="container grid-2 ">
        <div class="grid">
          <div class="cont-decor position-relative">
            <img src="/static/img/img-demo.jpg" class="img-decor">
            <h1 class="title">Richiedi una demo gratuita</h1>
            <div class="box-blue">
              <p class="subtitle">
                Il Software per la gestione della formazione finanziata.
              </p>
              <ul>
                <li>
                  <p>Aula Virtuale, per la gestione della formazione sincrona ed e-learning.</p>
                </li>
                <li>
                  <p>Firma Digitale, per certificare la propria presenza durante la formazione sincrona, asincrona ed in presenza.</p>
                </li>
                <li>
                  <p>Iformalia, un sistema flessibile e modulare per automatizzare il processo di gestione della formazione finanziata.</p>
                </li>
                <li>
                  <p>Rendizontazione: Gestione automatizzata del processo di rendicontazione e comunicazione delle informazioni verso il fondo di riferimento.</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="more-info">
            <p class="subtitle">
              Iformalia gestisce ed automatizza l'intero processo amministrativo della formazione finanziata generando per le imprese clienti una serie di vantaggi operativi, tra i quali:
            </p>
            <ul>

              <li>
                <p>Automatizza le attività ad alto valore aggiunto ma che hanno un livello di ripetitività elevata. </p>
              </li>
              <li>
                <p>Pannello di controllo per la verifica e la gestione dei corsi e di tutte le azioni riguardanti il corretto monitoraggio del piano formativo da finanziare. </p>
              </li>
              <li>
                <p>Gestione e follow-up in tempo reale delle attività riguardanti il piano formativo. </p>
              </li>
              <li>
                <p>Gestione automatizzata del processo di rendicontazione e comunicazione delle informazioni verso il fondo di riferimento.</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="grid grid-calendar">
          <div class="calendly-inline-widget" data-url="https://calendly.com/sandro-marsiglia"  style="min-width:320px;height:1200px;"></div>
          <component :is="'script'" ctype="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></component>
        </div>
      </section>



    </div>

  </section>

</template>

<script lang="js">
  export default {
    name: 'aviso-legal',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
  }
</script>

<style scoped>
  .politica-de-privacidad {}
</style>


// WEBPACK FOOTER //
// src/components/views/demo-richiedi.vue